import React from "react";
import { Page, BlockTitle, List, ListItem } from "framework7-react";
import HasRole from "modules/5_view_helpers/HasRole";
import { buildLocationNavItems, MobileNavList } from "modules/1_layout/mobile/AppSidebar/helpers";
import SyncStatusChip from "modules/offline/SyncStatusChip";
import { resolvePendingConflictsInteractively } from "modules/offline";

export const QASideBar = (props) => {
  const [, forceRerender] = React.useState();
  const { mobileCustomForms, mobileMenus, custom_forms } = props;
  const qaNavItems = buildLocationNavItems("quality_assurance", mobileCustomForms, mobileMenus, custom_forms);

  const SiteQARoles = HasRole({ category: "Site QA" }, true);
  const SiteInstallReadRole = HasRole(
    {
      resource_type: "Project::Qa::Site::SiteInstallation",
      name: ["read", "moderator"],
    },
    true
  );
  const ActionItemsReadRole = HasRole(
    {
      resource_type: "Project::Qa::ActionItem",
      name: ["read", "moderator"],
    },
    true
  );
  const surveillanceReadRole = HasRole({ resource_type: "Project::Qa::Site::Surveillance", name: ["read", "moderator"] }, true);

  const paintInspectionReadRole = HasRole(
    {
      resource_type: "Project::Qa::PaintInspection",
      name: ["read", "moderator"],
    },
    true
  );

  const weldingInspectionsReadRole = HasRole(
    {
      resource_type: "Project::Qa::WeldingInspection",
      name: ["read", "moderator"],
    },
    true
  );

  return (
    <Page>
      <div
        onClick={() => {
          if (props.offline_status?.conflictCount > 0) resolvePendingConflictsInteractively();
        }}
      >
        <SyncStatusChip />
      </div>
      <BlockTitle>QA Menu</BlockTitle>
      <List>
        {SiteQARoles && <ListItem title="Site Installation Dashboard" link="/project/qa/site/site_installations/dashboard" panelClose />}
        {SiteInstallReadRole && <ListItem title="Site Installation QA" link="/project/qa/site/site_installations" panelClose />}
        {ActionItemsReadRole && <ListItem title="Action Items" link="/project/qa/action_items" panelClose />}
        {surveillanceReadRole && <ListItem title="Surveillance Reports" link="/project/qa/site/surveillances" panelClose />}
        {paintInspectionReadRole && <ListItem title="Paint Inspections" link="/project/qa/paint_inspections" panelClose />}
        {weldingInspectionsReadRole && <ListItem title="Welding Inspections" link="/project/qa/welding_inspections" panelClose />}
      </List>
      <MobileNavList items={qaNavItems} />
      <List>
        <ListItem title="Back to Lion" link="/" panelClose onClick={forceRerender} />
      </List>
    </Page>
  );
};

export default QASideBar;
